module.exports = __webpack_public_path__ + "airtable-logo.png?991e0bb7c32893484c5584c134531e76";